import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { EzidebitCardPageRoutingModule } from './ezidebit-card-routing.module';
import { EzidebitCardPage } from './ezidebit-card.page';
import { MasterHeaderModule } from '../../../../master-header/master-header.module';
import { MasterFooterModule } from '../../../../master-footer/master-footer.module';
import { CustomInputModule } from 'src/app/master/common-components/custom-input/custom-input.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    EzidebitCardPageRoutingModule,
    MasterHeaderModule,
    MasterFooterModule,
    CustomInputModule,
    TranslateModule,
  ],
  declarations: [EzidebitCardPage],
})
export class EzidebitCardPageModule {}
